import i18n from 'constants/strings'
import React, { ReactNode } from 'react'
import InfoPanel from './InfoPanel'
import { Trans } from 'react-i18next'
import { FAQS_MY_MATCHES_HREF } from 'constants/global'

interface Props {
  icon?: ReactNode
  className?: string
}

const FeatureNotAvailablePanel = ({ icon, className = '' }: Props) => {
  return (
    <InfoPanel
      icon={icon}
      title={i18n.t('strMessageScreen.featureNotAvailable')}
      info={
        <Trans ns='strMessageScreen' i18nKey={'featureNotAvailableReadFaqs'}>
          <p>
            You may be ineligible for this feature. Please read our{' '}
            <a href={FAQS_MY_MATCHES_HREF} rel='noopener noreferrer' target='_blank'>
              FAQs
            </a>
            .
          </p>
        </Trans>
      }
      className={className}
    />
  )
}

export default FeatureNotAvailablePanel
